import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import VehicleImages from '../components/VehicleImages';

class WidgetContainer extends React.Component {
	render() {
		const { images, vehicle } = this.props;
		return <VehicleImages images={images} vehicle={vehicle} />;
	}
}
WidgetContainer.propTypes = {
	images: PropTypes.arrayOf(PropTypes.shape({ uri: PropTypes.string })),
	vehicle: PropTypes.shape({})
};
WidgetContainer.defaultProps = {
	images: [],
	vehicle: {}
};
const mapStateToProps = (state) => ({
	images: state.vehicleImages.images,
	vehicle: state.vehicleImages.vehicle
});
const mapDispatchToProps = (_dispatch) => ({});
const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);
export default Widget;
